import _ from 'lodash'

class WebServiceHelper {
  static getParameterizedUri(uriTemplate, parameters) {
    return _.reduce(
      parameters,
      (uri, value, key) => {
        return _.replace(uri, new RegExp(`{${key}}`), _.isNil(value) ? '' : value)
      },
      uriTemplate,
    )
  }

  static joinUrl(baseUrl, uri) {
    const cleanBaseUrl = _.replace(baseUrl, /\/$/, '')
    const cleanUri = _.replace(uri, /^\//, '')
    return `${cleanBaseUrl}/${cleanUri}`
  }
}

export default WebServiceHelper
